"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetClickedPunchCorrStatus = void 0;
const react_1 = require("react");
const useGetClickedPunchCorrStatus = (taskListGroups) => {
    const [clickedId, setClickedId] = (0, react_1.useState)();
    const findPunchCorrStatus = (id) => {
        if (!id) {
            return null;
        }
        let foundPunchCorrStatus = undefined;
        for (const taskListGroup of taskListGroups) {
            if (!taskListGroup.punchCorrectionStatus) {
                continue;
            }
            for (const punchCorrStatus of taskListGroup.punchCorrectionStatus) {
                if (punchCorrStatus.requestId === id) {
                    foundPunchCorrStatus = punchCorrStatus;
                    break;
                }
            }
        }
        return foundPunchCorrStatus;
    };
    const clickedPunchCorrStatus = findPunchCorrStatus(clickedId);
    return { clickedPunchCorrStatus, setClickedId };
};
exports.useGetClickedPunchCorrStatus = useGetClickedPunchCorrStatus;
